import { AdvisingAbnormalOperationUserBean } from './advising-abnormal-operation-user-bean';
import { AdvisingAbnormalTableAbnormalItemData } from "./advising-abnormal-table-abnormal-item-data";

export class AdvisingAbnormalTableAbnormalItemSaveRequest extends AdvisingAbnormalOperationUserBean {
  newAdvsingAbnormalItems: AdvisingAbnormalTableAbnormalItemData[];
  updatedAdvisingAbnormalItems: AdvisingAbnormalTableAbnormalItemData[];
  deletedAdvisingAbnormalItemSeqNos: number[];

  constructor() {
    super();
    this.newAdvsingAbnormalItems = [];
    this.updatedAdvisingAbnormalItems = [];
    this.deletedAdvisingAbnormalItemSeqNos = [];
  }
}
